import { TestimonialLarge } from "../../types/testimonial";

type Props = {
    largeTestimonials: TestimonialLarge[],
};

const TestimonialsGallery = ({
    largeTestimonials,
}: Props) => {

    return (
        <div className="row justify-content-center align-items-center pb-4">
            <div className="col-xxl-7 col-xl-8 col-lg-10 col-md-12 col-sm-10">
                <div className="row justify-content-center align-items-center">
                    {largeTestimonials.map((largeTesti, index) => (
                        <div className="col-md-3 col-6 px-1 py-2 text-center" key={index}>
                            <picture>
                                <source srcSet={largeTesti.imgWebp} type="image/webp" />
                                <img className="img-fluid rounded gg-img-customer-gallery" alt="Customer" src={largeTesti.img} loading="lazy" />
                            </picture>
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );
}

export default TestimonialsGallery;